
export default async function fetchGRPCAPI(
  path,
  userLocation,
  rangeValue,
  rangeUnit,
  pageNo,
  pageLimit,
  base_url,
) {
  if (!userLocation?.latitude || !userLocation?.longitude) return null;

  const url = new URL(`${base_url}${path}`);
  userLocation?.latitude &&
    url.searchParams.append("latitude", userLocation.latitude);
  userLocation?.longitude &&
    url.searchParams.append("longitude", userLocation.longitude);
  url.searchParams.append("distance", rangeValue);
  url.searchParams.append("limit", pageLimit);
  url.searchParams.append("page", pageNo);
  url.searchParams.append("distanceUnit", rangeUnit);

  const response = await fetch(url, {
    method: "GET",
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return { data };
}
